/**
 * The gallery files of a chat, in the order its messages are shown. An older message carries no id
 * and is skipped; a file that appears twice is listed once, where it first appears. Assembled from
 * the loaded messages, so a long chat steps through the part of its images that is on screen.
 */
export default function getConversationMediaFileIds(messages) {
    const fileIds = [];
    const seen = new Set();
    messages.forEach((message) => {
        const fileId = message.media_file_id;
        if (fileId === undefined || fileId.length === 0 || seen.has(fileId)) {
            return;
        }
        seen.add(fileId);
        fileIds.push(fileId);
    });
    return fileIds;
}
